import React, { PureComponent } from 'react';
import Dialog from 'rc-dialog';
import LimitesDisponibles from './LimitesDisponibles/LimitesDisponibles.jsx';
import AperturaSaldoActual from './AperturaSaldoActual/AperturaSaldoActual.jsx';
import MontoMask from "../../../Common/Components/Mask/MontoMask.jsx"

class SubHeader extends PureComponent {

    constructor(props) {
        super(props);
        this.state = { modalDetallesSaldos: false, modalDetallesLimites: false };
    }

    toggleModalDetallesSaldos() {
        this.setState({ modalDetallesSaldos: !this.state.modalDetallesSaldos });
    }

    toggleModalDetallesLimites() {
        this.setState({ modalDetallesLimites: !this.state.modalDetallesLimites });
    }

    render() {

        const { cambiarOpcionResumen, esCuentaCorriente, saldosResumenes, limiteDisponible } = this.props;
        const { saldosTotales } = saldosResumenes;
        const tituloSaldosResumenes = "Saldos y Res" + String.fromCharCode(250) + "menes";

        return (
            <div className="box header">
                <div className="row left-separator-xxs">
                    <div className="col-xs-5">
                        <div className="row">
                            <div className="col-xs-5 col-xs-offset-3">
                                <label className="label-secondary">Saldo Actual</label>
                            </div>
                            <div className="col-xs-6">
                                <MontoMask monto={saldosTotales && saldosTotales.SaldoPesos} moneda={"pesos"} />
                            </div>
                            <div className="col-xs-6">
                                <MontoMask monto={saldosTotales && saldosTotales.SaldoUsd} moneda={"dolares"}  />
                            </div>
                            <div className="col-xs-5 col-xs-offset-3">
                                <a id="detallesSaldo" className="btn-link btn-link-labeled-primary ti-sm" onClick={this.toggleModalDetallesSaldos.bind(this)}>Ver Detalles</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-1 no-padding text-center">
                        <label className="divisor"></label>
                    </div>
                    <div className="col-xs-6">
                        <div className="row">
                            <div className="col-xs-5 col-xs-offset-3">
                                <label className="label-secondary">Límite de Compra</label>
                            </div>
                            <div className="col-xs-5 col-xs-offset-3">
                                <MontoMask monto={limiteDisponible && limiteDisponible.LimiteDeCompra} moneda={"pesos"} />
                            </div>
                            <div className="col-xs-5 col-xs-offset-3">
                                <a className="btn-link btn-link-labeled-primary ti-sm" onClick={() => this.toggleModalDetallesLimites()}>Ver Detalles</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row top-separator-xxs">

                    <div className="col-xs-6 no-padding-right">
                        <button
                            className={(!esCuentaCorriente ? "btn btn-cta3 width-100 boton saldos-resumenes-tab-activo" : "btn btn-cta2 width-100 boton")}
                            type="button"
                            onClick={() => cambiarOpcionResumen(false)}
                        >
                            {tituloSaldosResumenes}
                 </button>
                    </div>

                    <div className="col-xs-6 no-padding-left">
                        <button
                            className={(esCuentaCorriente ? "btn btn-cta3 width-100 boton saldos-resumenes-tab-activo" : "btn btn-cta2 width-100 boton")}
                            type="button"
                            onClick={() => cambiarOpcionResumen(true)}>
                            Cuenta Corriente
                </button>
                    </div>

                </div>

                <div>
                    <Dialog
                        visible={this.state.modalDetallesSaldos}
                        onClose={() => this.toggleModalDetallesSaldos()}
                        animation="slide-fade"
                        maskAnimation="fade"
                        style={{
                            width: 892,
                            height: 502
                        }}
                        className="saldos-resumenes"
                        title="Saldo Actual"
                    >
                        <AperturaSaldoActual
                            saldosResumenes={saldosResumenes}
                        />
                    </Dialog>

                    <Dialog
                        visible={this.state.modalDetallesLimites}
                        onClose={() => this.toggleModalDetallesLimites()}
                        animation="slide-fade"
                        maskAnimation="fade"
                        style={{
                            width: 892,
                            height: 502
                        }}
                        title={"L" + String.fromCharCode(237) + "mites"}
                        footer={[
                            <button
                                type="button"
                                className="btn btn-default"
                                key="close"
                                onClick={() => this.toggleModalDetallesLimites()}
                            >
                                Cerrar
                </button>
                        ]}
                    >
                        <LimitesDisponibles
                            limiteDisponible={limiteDisponible} />
           </Dialog>

                </div>

            </div>
        );
    }
}

export default SubHeader;